import React from "react";
import "./App.css";
import { Switch, useLocation } from "react-router-dom";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/Login/Login";
import SideMenu from "./components/SideMenu/SideMenu";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import SearchAndStatus from "./pages/SearchAndStatus/SearchAndStatus";
import DealerProfile from "./pages/DealerProfile/DealerProfile";
import CustomerProfile from "./pages/CustomerProfile/CustomerProfile";
import DealerSearch from "./pages/DealerModule/DealerSearch";

function App() {
  const location = useLocation();
  return (
    <Layout>
      {location.pathname !== "/" && <SideMenu /> &&
        location.pathname !== "/login" && <SideMenu />}
      <Layout>
        <Content
          style={{ margin: "0 0 0 16px", overflow: "auto", height: "100vh" }}
        >
          <Switch>
            <PublicRoute path="/" component={Login} restricted={false} exact />
            <PublicRoute
              path="/login"
              component={Login}
              restricted={false}
              exact
            />
            <PrivateRoute path="/sidemenu" component={SideMenu} exact />
            <PrivateRoute path="/search" component={SearchAndStatus} exact />
            <PrivateRoute path="/Dealer/Profile" component={DealerProfile} exact />
            <PrivateRoute path="/Dealer/search" component={DealerSearch} exact />
            <PrivateRoute
              path="/customer/profile"
              component={CustomerProfile}
              exact
            />
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
}
export default App;
